// Stubs for the calendar holidays — Easter, Thanksgiving,
// Christmas, NYE, Valentines. These surface for 1-3 weeks
// before the date (per `leadDays` in tags.js).

export const HOLIDAY_STUBS = [
  // ── Easter ─────────────────────────────────────────────────
  {
    id: "honey-glazed-ham",
    title: "Honey-Glazed Ham",
    emoji: "🍖",
    blurb: "Spiral-cut ham with sticky brown sugar crust",
    discoveryTags: ["easter", "christmas", "sunday-dinner", "comfort-food"],
    cuisine: "american",
    course: "main",
    mealTiming: "dinner",
    difficulty: "easy",
    estimatedTime: 150,
    keyIngredients: ["ham", "honey", "brown_sugar", "dijon_mustard"],
    buildHint: "score the fat in diamonds, glaze of honey + brown sugar + dijon + clove brushed every 20 min, low oven 325F until 140F internal, broil last 5 for crust",
    producesCanonical: null,
  },
  {
    id: "deviled-eggs",
    title: "Deviled Eggs",
    emoji: "🥚",
    blurb: "Creamy yolk filling, paprika dust",
    discoveryTags: ["easter", "thanksgiving", "christmas", "cookout", "july4th", "memorialDay"],
    cuisine: "american",
    course: "appetizer",
    mealTiming: "dinner",
    difficulty: "easy",
    estimatedTime: 30,
    keyIngredients: ["eggs", "mayonnaise", "dijon_mustard"],
    buildHint: "ice-bath shocked hard-boiled eggs peel clean, yolks mashed with mayo + dijon + vinegar + salt, piped back with paprika dust on top",
    producesCanonical: null,
  },

  // ── Thanksgiving ──────────────────────────────────────────
  {
    id: "roast-turkey",
    title: "Roast Turkey",
    emoji: "🦃",
    blurb: "Brined bird, golden skin, juicy carving",
    discoveryTags: ["thanksgiving", "christmas", "sunday-dinner"],
    cuisine: "american",
    course: "main",
    mealTiming: "dinner",
    difficulty: "medium",
    estimatedTime: 300,
    keyIngredients: ["turkey", "butter", "thyme", "sage", "onion"],
    buildHint: "dry brine 1-3 days for juicy + crisp skin, butter under skin, aromatics in cavity, roast 325F until 165F breast / 175F thigh, rest 30 min",
    producesCanonical: null,
  },
  {
    id: "mashed-potatoes",
    title: "Mashed Potatoes",
    emoji: "🥔",
    blurb: "Buttery, creamy, classic side",
    discoveryTags: ["thanksgiving", "christmas", "sunday-dinner", "comfort-food", "kids"],
    cuisine: "american",
    course: "side",
    mealTiming: "dinner",
    difficulty: "easy",
    estimatedTime: 35,
    keyIngredients: ["potatoes", "butter", "heavy_cream", "salt"],
    buildHint: "Yukon Gold or russet, started in cold salted water, drained well, butter melted into hot potatoes BEFORE cream so they absorb fat, season aggressively",
    producesCanonical: null,
  },
  {
    id: "stuffing",
    title: "Bread Stuffing",
    emoji: "🍞",
    blurb: "Sage and onion bread dressing",
    discoveryTags: ["thanksgiving", "christmas", "sunday-dinner", "comfort-food"],
    cuisine: "american",
    course: "side",
    mealTiming: "dinner",
    difficulty: "easy",
    estimatedTime: 75,
    keyIngredients: ["bread", "butter", "onion", "celery", "sage", "chicken_stock"],
    buildHint: "stale cubed bread (or oven-dried), sauté onion + celery in lots of butter, toss with stock + eggs + sage, bake covered 30 min then uncovered for crust",
    producesCanonical: null,
  },
  {
    id: "pumpkin-pie",
    title: "Pumpkin Pie",
    emoji: "🥧",
    blurb: "Spiced custard in flaky crust, whipped cream",
    discoveryTags: ["thanksgiving", "christmas", "comfort-food"],
    cuisine: "american",
    course: "dessert",
    mealTiming: "dinner",
    difficulty: "medium",
    estimatedTime: 90,
    keyIngredients: ["puff_pastry", "pumpkin_puree", "eggs", "heavy_cream", "cinnamon", "nutmeg"],
    buildHint: "blind bake crust 10 min so it's not soggy, custard of pumpkin + eggs + cream + spices, bake 350F until edges set + center barely jiggles",
    producesCanonical: null,
  },

  // ── Christmas / NYE ───────────────────────────────────────
  {
    id: "prime-rib-roast",
    title: "Prime Rib Roast",
    emoji: "🥩",
    blurb: "Crusted standing rib roast, pink throughout",
    discoveryTags: ["christmas", "newYearsEve", "sunday-dinner", "date-night"],
    cuisine: "american",
    course: "main",
    mealTiming: "dinner",
    difficulty: "medium",
    estimatedTime: 180,
    keyIngredients: ["beef_rib_roast", "garlic", "rosemary", "butter"],
    buildHint: "salt + pepper crust 24h ahead uncovered in fridge, reverse-sear method — 225F until 120F internal, rest, blast 500F for crust",
    producesCanonical: null,
  },

  // ── Valentine's ───────────────────────────────────────────
  {
    id: "filet-mignon",
    title: "Filet Mignon",
    emoji: "🥩",
    blurb: "Pan-seared, butter-basted, red wine pan sauce",
    discoveryTags: ["valentines", "date-night", "newYearsEve"],
    cuisine: "french",
    course: "main",
    mealTiming: "dinner",
    difficulty: "medium",
    estimatedTime: 30,
    keyIngredients: ["filet_mignon", "butter", "thyme", "garlic", "red_wine"],
    buildHint: "room temp steak, ripping hot cast iron, sear 3 min/side, butter baste with thyme + garlic to 125F, rest 5, pan sauce with shallot + wine + butter",
    producesCanonical: null,
  },
  {
    id: "chocolate-souffle",
    title: "Chocolate Soufflé",
    emoji: "🍫",
    blurb: "Light-as-air chocolate, fresh from the oven",
    discoveryTags: ["valentines", "date-night", "newYearsEve"],
    cuisine: "french",
    course: "dessert",
    mealTiming: "dinner",
    difficulty: "advanced",
    estimatedTime: 45,
    keyIngredients: ["dark_chocolate", "eggs", "butter", "sugar"],
    buildHint: "butter + sugar ramekins, melted chocolate + yolks base, fold in stiff egg whites GENTLY, bake immediately 400F until risen + still jiggly center",
    producesCanonical: null,
  },
];
